import { useLoaderData } from 'react-router-dom';
import { useContext } from 'react';
import {
  LocalWidgetRouterContext,
  LocalWidgetRouterState,
  WidgetRouteContext,
} from '@/core/widgets/contexts/local-widget-router-context';

// Like react-router's useLoaderData: returns the data of the route whose
// element is calling it, so a layout gets its own loader's data and a leaf
// gets the leaf's. Outside the route chain it falls back to the leaf's data.
export default function useWidgetLoaderData() {
  const context = useContext<LocalWidgetRouterState>(LocalWidgetRouterContext);
  const route = useContext(WidgetRouteContext);

  let d;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    d = useLoaderData();
  } catch {
    d = undefined;
  }

  if (context.useLocal) {
    return route ? route.loaderData : context.loaderData;
  }

  return d;
}
